// Sentry is temporarily disabled. Keep the package installed for later reactivation.
// import './sentry';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// import * as Sentry from '@sentry/react';

// import ErrorFallBack from './components/ErrorFallBack';
import './css/base.css';
import './index.css';

import dayjs from 'dayjs';
import en from 'dayjs/locale/en';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import dayOfYear from 'dayjs/plugin/dayOfYear';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import utc from 'dayjs/plugin/utc';
import weekOfYear from 'dayjs/plugin/weekOfYear';

import { Provider } from 'react-redux';
import { App } from './App.tsx';
import reportWebVitals from './reportWebVitals';
import { store } from './store/index.ts';

dayjs.extend(dayOfYear);
dayjs.extend(weekOfYear);
dayjs.extend(quarterOfYear);
dayjs.extend(advancedFormat);
dayjs.extend(utc);

dayjs.locale({
  ...en,
  weekStart: 1,
});

async function bootstrap() {
  if (import.meta.env.VITE_ROVER_NOTIFICATIONS_MOCK === 'true') {
    const { http } = await import('@/api/Rover/notifications/roverNotifications');
    const { installMockAdapter } = await import('@/mocks/roverNotifications/mockAdapter');
    installMockAdapter(http);
  }

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      {/* Sentry error boundary is temporarily disabled. */}
      <Provider store={store}>
        <App />
      </Provider>
    </StrictMode>
  );

  reportWebVitals();
}

void bootstrap();
